import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  Badge,
  Modal,
  Tab,
  Nav,
  Table,
} from "react-bootstrap";
import {
  FaSearch,
  FaSave,
  FaArrowLeft,
  FaCheckCircle,
  FaTimesCircle,
  FaCar,
  FaUser,
  FaBuilding,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCalendar,
  FaFileAlt,
  FaShieldAlt,
  FaCog,
  FaDatabase,
  FaUpload,
  FaTruckMoving,
  FaBus,
  FaClipboardCheck,
  FaFileContract,
  FaMapMarkedAlt,
  FaEye,
} from "react-icons/fa";
import { RiEBikeFill } from "react-icons/ri";
import { BsBatteryCharging } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Baseurl, mapApiKey } from "../../baseurl";
import { useSelector } from "react-redux";

const AddCase = () => {
  const navigate = useNavigate();
  const { loginData } = useSelector((store) => store.auth);
  const [clientList, setClientList] = useState([]);
  useEffect(() => {
    const getClientDetails = async () => {
      const url = `${Baseurl}/api/client/all`;
      const resp = await axios.get(url);
      if (resp.data.success) {
        console.log(resp.data.clients[0], "resp.data.clients");
        setClientList(resp.data.clients);
      }
    };
    getClientDetails();
  }, []);
  // Vehicle type options
  const vehicleTypeOptions = [
    { value: "evTwoWheeler", label: "EV Two Wheeler", icon: <RiEBikeFill /> },
    {
      value: "evThreeWheeler",
      label: "EV Three Wheeler",
      icon: <RiEBikeFill />,
    },
    { value: "evFourWheeler", label: "EV Four Wheeler", icon: <FaCar /> },
    { value: "evCommercial", label: "EV Commercial", icon: <FaTruckMoving /> },
    { value: "evBus", label: "EV Bus", icon: <FaBus /> },
  ];

  // Case type options
  const caseTypeOptions = [
    { value: "valuation", label: "Valuation", icon: <FaClipboardCheck /> },
    { value: "revaluation", label: "Revaluation", icon: <FaClipboardCheck /> },
    { value: "sale", label: "Sale", icon: <FaClipboardCheck /> },
    { value: "auction", label: "Auction", icon: <FaClipboardCheck /> },
    { value: "insurance", label: "Insurance", icon: <FaShieldAlt /> },
    { value: "loan", label: "Loan Processing", icon: <FaFileAlt /> },
  ];

  // Initial empty form state
  const initialFormData = {
    // Case Details
    caseType: "",
    vehicleType: "",

    // Requester Details
    requesterID: "",
    requesterName: "",
    requesterBranch: "",
    requesterPhone: "",

    // Borrower Details
    borrowerName: "",
    borrowerPhoneNo: "",
    borrowerEmail: "",
    borrowerAddress: "",
    borrowerCity: "",
    borrowerState: "",
    borrowerCoordinates: {
      lat: "",
      lng: "",
    },

    // Vehicle Details
    regdNo: "",
    brand: "",
    model: "",
    variant: "",
    regdOwner: "",
    regdDate: "",

    // Additional Vehicle Details (to be filled from Vahan)
    engNo: "",
    chasisNo: "",
    bodyType: "",
    manufacturingDate: "",
    meterReading: "",
    vehicleColor: "",
    ownerSerialNo: "",
    hypothecationBank: "",
    insuranceCompany: "",
    insuranceStatus: "",
    cubicCapacity: "",
    seatingCapacity: "",
    vehicleWeight: "",
  };

  // Form state
  const [formData, setFormData] = useState(initialFormData);

  // UI State
  const [loading, setLoading] = useState(false);
  const [fetchingVahan, setFetchingVahan] = useState(false);
  const [fetchingCoordinates, setFetchingCoordinates] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showVahanModal, setShowVahanModal] = useState(false);
  const [vahanData, setVahanData] = useState(null);
  const [vahanFetched, setVahanFetched] = useState(false);
  const [activeTab, setActiveTab] = useState("vehicle");

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle nested coordinates
    if (name.startsWith("borrowerCoordinates.")) {
      const coordField = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        borrowerCoordinates: {
          ...prev.borrowerCoordinates,
          [coordField]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Handle select changes
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleReqesterData = async (dataID) => {
    const findClient = clientList.find((indClient) => indClient._id === dataID);
    console.log(findClient, "findClient");
    setFormData((prev) => ({
      ...formData,
      requesterID: findClient._id,
      requesterName: findClient.name,
      requesterBranch: findClient.organisation,
      requesterPhone: findClient.phone,
    }));
  };
  console.log(formData, "formData");
  console.log(vahanData, "vahanData");
  // Fetch Vahan details
  const fetchVahanDetails = async () => {
    if (!formData.regdNo.trim()) {
      setError("Please enter a registration number");
      return;
    }

    if (!formData.regdNo.match(/^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{1,4}$/i)) {
      setError("Please enter a valid registration number (e.g., TN01EV7788)");
      return;
    }

    const uploadData = {
      regdNo: formData.regdNo,
    };
    setFetchingVahan(true);
    setError("");
    setSuccess("");

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "t0itN3Np4tAJZjd7wPKlHvMpWWKj1fiU",
        },
      };
      const url = `https://instavaluermainapi.instavaluer.com/api/v1/cases/sendvehiclenumber`;
      const resp = await axios.post(url, uploadData, config);

      if (resp.data.success) {
        const vahanData = resp.data.response?.result;
        setVahanData(vahanData);
        setVahanFetched(true);
        setShowVahanModal(true);

        // Auto-fill form with Vahan data
        const updatedForm = {
          ...formData,
          brand: vahanData.vehicleManufacturerName || formData.brand,
          model: vahanData.model || formData.model,
          regdOwner: vahanData.owner || formData.regdOwner,
          regdDate: vahanData.regDate || formData.regdDate,
          engNo: vahanData.engine || formData.engNo,
          chasisNo: vahanData.chassis || formData.chasisNo,
          bodyType: vahanData.bodyType || formData.bodyType,
          manufacturingDate:
            vahanData.vehicleManufacturingMonthYear ||
            formData.manufacturingDate,
          vehicleColor: vahanData.vehicleColour || formData.vehicleColor,
          ownerSerialNo: vahanData.ownerCount || formData.ownerSerialNo,
          insuranceCompany:
            vahanData.vehicleInsuranceCompanyName || formData.insuranceCompany,
          cubicCapacity:
            vahanData.vehicleCubicCapacity || formData.cubicCapacity,
          seatingCapacity:
            vahanData.vehicleSeatCapacity || formData.seatingCapacity,
          vehicleWeight: vahanData.grossVehicleWeight || formData.vehicleWeight,
          vehicleEdetails: {
            blacklistStatus: vahanData?.blacklistStatus,
            bodyType: vahanData?.bodyType,
            chassis: vahanData?.chassis,
            engine: vahanData?.engine,
            grossVehicleWeight: vahanData?.grossVehicleWeight,
            isCommercial: vahanData?.isCommercial,
            model: vahanData?.model,
            normsType: vahanData?.normsType,
            owner: vahanData?.owner,
            ownerCount: vahanData?.ownerCount,
            ownerFatherName: vahanData?.ownerFatherName,
            permanentAddress: vahanData?.permanentAddress,
            presentAddress: vahanData?.presentAddress,
            rcExpiryDate: vahanData?.rcExpiryDate,
            rcFinancer: vahanData?.rcFinancer,
            rcStandardCap: vahanData?.rcStandardCap,
            regAuthority: vahanData?.regAuthority,
            regDate: vahanData?.regDate,
            regNo: vahanData?.regNo,
            status: vahanData?.status,
            statusAsOn: vahanData?.statusAsOn,
            type: vahanData?.type,
            unladenWeight: vahanData?.unladenWeight,
            vehicleCategory: vahanData?.vehicleCategory,
            vehicleClass: vahanData?.vehicleClass,
            vehicleColour: vahanData?.vehicleColour,
            vehicleCubicCapacity: vahanData?.vehicleCubicCapacity,
            vehicleCylindersNo: vahanData?.vehicleCylindersNo,
            vehicleInsuranceCompanyName: vahanData?.vehicleInsuranceCompanyName,
            vehicleInsurancePolicyNumber:
              vahanData?.vehicleInsurancePolicyNumber,
            vehicleInsuranceUpto: vahanData?.vehicleInsuranceUpto,
            vehicleManufacturerName: vahanData?.vehicleManufacturerName,
            vehicleManufacturingMonthYear:
              vahanData?.vehicleManufacturingMonthYear,
            vehicleNumber: vahanData?.vehicleNumber,
            vehicleSeatCapacity: vahanData?.vehicleSeatCapacity,
            vehicleTaxUpto: vahanData?.vehicleTaxUpto,
            permitValidUpto: vahanData?.permitValidUpto,
            permitType: vahanData?.permitType,
            wheelbase: vahanData?.wheelbase,
          },
        };

        setFormData(updatedForm);
        setSuccess("Vahan details fetched successfully!");
      } else {
        setError("Vehicle not found in Vahan database");
      }
    } catch (err) {
      console.error("Error fetching Vahan details:", err);
      setError("Failed to fetch Vahan details. Please try again.");

      // Mock data for demo purposes
      const mockVahanData = {
        vehicleNumber: formData.regdNo.toUpperCase(),
        status: "ACTIVE",
        vehicleManufacturerName: "",
        model: "",
        owner: "",
        regDate: "",
        rcExpiryDate: "",
        engine: "",
        chassis: "",
        bodyType: "",
        vehicleManufacturingMonthYear: "",
        vehicleColour: "",
        ownerCount: "",
        vehicleInsuranceCompanyName: "",
        vehicleCubicCapacity: "",
        vehicleSeatCapacity: "",
        grossVehicleWeight: "",
        vehicleInsuranceUpto: "",
        vehicleTaxUpto: "",
        puccUpto: "",
      };

      // Fill mock data based on vehicle type
      switch (formData.vehicleType) {
        case "evBus":
          mockVahanData.vehicleManufacturerName = "Olectra";
          mockVahanData.model = "K9";
          mockVahanData.bodyType = "BUS";
          mockVahanData.vehicleSeatCapacity = "40";
          mockVahanData.grossVehicleWeight = "12000";
          break;
        case "evFourWheeler":
          mockVahanData.vehicleManufacturerName = "Tata";
          mockVahanData.model = "Nexon EV";
          mockVahanData.bodyType = "SUV";
          mockVahanData.vehicleSeatCapacity = "5";
          mockVahanData.grossVehicleWeight = "1400";
          break;
        case "evTwoWheeler":
          mockVahanData.vehicleManufacturerName = "Ola Electric";
          mockVahanData.model = "S1 Pro";
          mockVahanData.bodyType = "SCOOTER";
          mockVahanData.vehicleSeatCapacity = "2";
          mockVahanData.grossVehicleWeight = "125";
          break;
      }

      setVahanData(mockVahanData);
      setVahanFetched(true);
      setShowVahanModal(true);

      const updatedForm = {
        ...formData,
        brand: mockVahanData.vehicleManufacturerName,
        model: mockVahanData.model,
        regdOwner: mockVahanData.owner,
        regdDate: mockVahanData.regDate,
        engNo: mockVahanData.engine,
        chasisNo: mockVahanData.chassis,
        bodyType: mockVahanData.bodyType,
        manufacturingDate: mockVahanData.vehicleManufacturingMonthYear,
        vehicleColor: mockVahanData.vehicleColour,
        ownerSerialNo: mockVahanData.ownerCount,
        insuranceCompany: mockVahanData.vehicleInsuranceCompanyName,
        cubicCapacity: mockVahanData.vehicleCubicCapacity,
        seatingCapacity: mockVahanData.vehicleSeatCapacity,
        vehicleWeight: mockVahanData.grossVehicleWeight,
      };

      setFormData(updatedForm);
      setSuccess("Mock Vahan details loaded for demo");
    } finally {
      setFetchingVahan(false);
    }
  };

  // Show fetched Vahan details
  const showVahanDetails = () => {
    if (vahanData) {
      setShowVahanModal(true);
    }
  };

  // Apply Vahan data to form
  const applyVahanData = () => {
    if (vahanData) {
      const updatedForm = {
        ...formData,
        brand: vahanData.vehicleManufacturerName || formData.brand,
        model: vahanData.model || formData.model,
        regdOwner: vahanData.owner || formData.regdOwner,
        regdDate: vahanData.regDate || formData.regdDate,
        engNo: vahanData.engine || formData.engNo,
        chasisNo: vahanData.chassis || formData.chasisNo,
        bodyType: vahanData.bodyType || formData.bodyType,
        manufacturingDate:
          vahanData.vehicleManufacturingMonthYear || formData.manufacturingDate,
        vehicleColor: vahanData.vehicleColour || formData.vehicleColor,
        ownerSerialNo: vahanData.ownerCount || formData.ownerSerialNo,
        insuranceCompany:
          vahanData.vehicleInsuranceCompanyName || formData.insuranceCompany,
        cubicCapacity: vahanData.vehicleCubicCapacity || formData.cubicCapacity,
        seatingCapacity:
          vahanData.vehicleSeatCapacity || formData.seatingCapacity,
        vehicleWeight: vahanData.grossVehicleWeight || formData.vehicleWeight,
      };

      setFormData(updatedForm);
      setShowVahanModal(false);
      setSuccess("Vahan data applied to form successfully!");
    }
  };

  // Fetch coordinates using Google Geocoding API
  const fetchCoordinates = async () => {
    if (!formData.borrowerAddress.trim()) {
      setError("Please enter Borrower Address first");
      return;
    }

    setFetchingCoordinates(true);
    setError("");

    try {
      // Google Geocoding API
      const address = encodeURIComponent(
        `${formData.borrowerAddress}, ${formData.borrowerCity}, ${formData.borrowerState}`,
      );
      const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${mapApiKey}`;

      const response = await axios.get(url);

      if (response.data.status === "OK" && response.data.results.length > 0) {
        const location = response.data.results[0].geometry.location;

        setFormData((prev) => ({
          ...prev,
          borrowerCoordinates: {
            lat: location.lat.toString(),
            lng: location.lng.toString(),
          },
        }));

        setSuccess("Coordinates fetched successfully!");
      } else {
        setError("Unable to fetch coordinates. Please check the address.");
      }
    } catch (err) {
      console.error("Error fetching coordinates:", err);
      setError("Failed to fetch coordinates. Please try again.");

      // Mock coordinates for demo purposes
      setFormData((prev) => ({
        ...prev,
        borrowerCoordinates: {
          lat: "13.0827",
          lng: "80.2707",
        },
      }));
      setSuccess("Demo coordinates loaded (Chennai coordinates)");
    } finally {
      setFetchingCoordinates(false);
    }
  };

  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return "N/A";
    }
    if (Array.isArray(value) && value.length === 0) {
      return "None";
    }
    return value;
  };

  // View Vahan details in full page
  const viewFullVahanDetails = () => {
    // Store vahan data in sessionStorage for VahanDetailsPage
    if (vahanData) {
      sessionStorage.setItem("vehicleData", JSON.stringify(vahanData));
      navigate("/vahan-details");
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    // Validation
    if (!formData.caseType || !formData.vehicleType) {
      setError("Please select Case Type and Vehicle Type");
      setLoading(false);
      return;
    }

    if (!formData.regdNo) {
      setError("Please enter Registration Number");
      setLoading(false);
      return;
    }

    try {
      const organisation =
        loginData.role === "admin"
          ? {
              id: loginData._id,
              email: loginData?.email,
              name: loginData.organisation,
              phn: loginData?.phone,
              logo: loginData?.logo,
            }
          : {
              id: loginData.organisation?.id,
              email: loginData.organisation?.email,
              name: loginData.organisation?.name,
              phn: loginData.organisation?.phn,
              logo: loginData.organisation?.logo,
            };
      const createdBy =
        loginData.role === "admin"
          ? {
              id: loginData._id,
              email: loginData?.email,
              name: loginData.organisation,
              phn: loginData?.phone,
            }
          : {
              id: loginData.organisation?.id,
              email: loginData.organisation?.email,
              name: loginData.organisation?.name,
              phn: loginData.organisation?.phn,
            };
      const updatedData = {
        ...formData,
        organisation,
        createdBy
      };
      console.log("updatedData:", updatedData);
      // Submit form data to API
      const response = await axios.post(
        `${Baseurl}/api/cases/create`,
        updatedData,
      );

      if (response.data.success) {
        setSuccess("Case created successfully!");
        // Reset form after successful submission
        setTimeout(() => {
          setFormData(initialFormData);
          setVahanFetched(false);
          setVahanData(null);
          navigate("/cases");
        }, 2000);
      } else {
        setError(response.data.message || "Failed to create case");
      }
    } catch (err) {
      console.error("Error creating case:", err);
      setError("Failed to create case. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const handleReset = () => {
    setFormData(initialFormData);
    setVahanFetched(false);
    setVahanData(null);
    setError("");
    setSuccess("");
  };

  return (
    <div className="py-4">
      <Row className="mb-4">
        <Col>
          <Button
            variant="outline-primary"
            onClick={() => navigate(-1)}
            className="mb-3"
          >
            <FaArrowLeft /> Back
          </Button>
          <h2 className="mb-0">
            <FaFileContract className="me-2" />
            Create New Case
          </h2>
          <p className="text-muted">
            Fill in the details below to create a new valuation case
          </p>
        </Col>
      </Row>

      {/* Search Section */}
      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-primary text-white d-flex align-items-center">
          <FaDatabase className="me-2" />
          <h5 className="mb-0">Vehicle Information</h5>
        </Card.Header>
        <Card.Body>
          <Row className="align-items-end">
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  <strong>Vehicle Registration Number *</strong>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="regdNo"
                  value={formData.regdNo}
                  onChange={handleInputChange}
                  placeholder="Enter registration number (e.g., TN01EV7788)"
                  required
                />
                <Form.Text className="text-muted">
                  Enter the vehicle's registration number to fetch details from
                  Vahan database
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <div className="d-flex gap-2 mt-3">
                <Button
                  variant="primary"
                  onClick={fetchVahanDetails}
                  disabled={fetchingVahan || !formData.regdNo.trim()}
                  className="flex-grow-1"
                >
                  {fetchingVahan ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Fetching Vahan...
                    </>
                  ) : (
                    <>
                      <FaSearch className="me-2" />
                      Fetch Vahan Details
                    </>
                  )}
                </Button>

                {vahanFetched && vahanData && (
                  <Button
                    variant="outline-success"
                    onClick={showVahanDetails}
                    className="flex-shrink-0"
                  >
                    <FaEye className="me-2" />
                    Show Details
                  </Button>
                )}
              </div>
            </Col>
          </Row>

          {formData.regdNo && !vahanFetched && (
            <Alert variant="info" className="mt-3">
              <strong>Note:</strong> Click "Fetch Vahan Details" to get vehicle
              information from the database.
            </Alert>
          )}

          {vahanFetched && (
            <Alert variant="success" className="mt-3">
              <FaCheckCircle className="me-2" />
              Vahan details fetched successfully! Click "Show Details" to view
              or edit the fetched data.
            </Alert>
          )}
        </Card.Body>
      </Card>

      {/* Messages */}
      {error && (
        <Alert variant="danger" onClose={() => setError("")} dismissible>
          <FaTimesCircle className="me-2" />
          {error}
        </Alert>
      )}

      {success && (
        <Alert variant="success" onClose={() => setSuccess("")} dismissible>
          <FaCheckCircle className="me-2" />
          {success}
        </Alert>
      )}

      {/* Main Form */}
      <Form onSubmit={handleSubmit}>
        <Card className="mb-4 shadow-sm">
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <FaClipboardCheck className="me-2" />
              Case Details
            </h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Case Type *</strong>
                  </Form.Label>
                  <Form.Select
                    name="caseType"
                    value={formData.caseType}
                    onChange={handleSelectChange}
                    required
                  >
                    <option value="">Select Case Type</option>
                    {caseTypeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Vehicle Type *</strong>
                  </Form.Label>
                  <Form.Select
                    name="vehicleType"
                    value={formData.vehicleType}
                    onChange={handleSelectChange}
                    required
                  >
                    <option value="">Select Vehicle Type</option>
                    {vehicleTypeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Tabs Navigation */}
        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Card className="mb-4 shadow-sm">
            <Card.Header className="bg-light">
              <Nav variant="tabs" className="border-bottom-0">
                <Nav.Item>
                  <Nav.Link
                    eventKey="vehicle"
                    className="d-flex align-items-center"
                  >
                    <FaCar className="me-2" />
                    Vehicle Details
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="requester"
                    className="d-flex align-items-center"
                  >
                    <FaUser className="me-2" />
                    Requester Details
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="borrower"
                    className="d-flex align-items-center"
                  >
                    <FaBuilding className="me-2" />
                    Borrower Details
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="additional"
                    className="d-flex align-items-center"
                  >
                    <FaCog className="me-2" />
                    Additional Details
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>

            <Card.Body>
              <Tab.Content>
                {/* Vehicle Details Tab */}
                <Tab.Pane eventKey="vehicle">
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Brand *</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="brand"
                          value={formData.brand}
                          onChange={handleInputChange}
                          placeholder="Enter brand (e.g., Olectra)"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Model *</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="model"
                          value={formData.model}
                          onChange={handleInputChange}
                          placeholder="Enter model (e.g., K9)"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Variant</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="variant"
                          value={formData.variant}
                          onChange={handleInputChange}
                          placeholder="Enter variant (e.g., Electric AC)"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Registration Owner *</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="regdOwner"
                          value={formData.regdOwner}
                          onChange={handleInputChange}
                          placeholder="Enter registered owner name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Registration Date</strong>
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="regdDate"
                          value={formData.regdDate}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Body Type</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="bodyType"
                          value={formData.bodyType}
                          onChange={handleInputChange}
                          placeholder="Enter body type"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Engine Number</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="engNo"
                          value={formData.engNo}
                          onChange={handleInputChange}
                          placeholder="Enter engine number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Chassis Number</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="chasisNo"
                          value={formData.chasisNo}
                          onChange={handleInputChange}
                          placeholder="Enter chassis number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Manufacturing Date</strong>
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="manufacturingDate"
                          value={formData.manufacturingDate}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Vehicle Color</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="vehicleColor"
                          value={formData.vehicleColor}
                          onChange={handleInputChange}
                          placeholder="Enter vehicle color"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Seating Capacity</strong>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="seatingCapacity"
                          value={formData.seatingCapacity}
                          onChange={handleInputChange}
                          placeholder="Enter seating capacity"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Vehicle Weight (kg)</strong>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="vehicleWeight"
                          value={formData.vehicleWeight}
                          onChange={handleInputChange}
                          placeholder="Enter vehicle weight"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab.Pane>

                {/* Requester Details Tab */}
                <Tab.Pane eventKey="requester">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Requester ID *</strong>
                        </Form.Label>
                        <Form.Select
                          name="vehicleType"
                          value={formData.requesterID}
                          onChange={(e) => handleReqesterData(e.target.value)}
                          required
                        >
                          <option value="">Select Requester ID</option>
                          {clientList.map((option) => (
                            <option key={option.value} value={option._id}>
                              {option.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Requester Name *</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="requesterName"
                          value={formData.requesterName}
                          onChange={handleInputChange}
                          placeholder="Enter requester name"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Requester Branch</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="requesterBranch"
                          value={formData.requesterBranch}
                          onChange={handleInputChange}
                          placeholder="Enter branch name"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Requester Phone *</strong>
                        </Form.Label>
                        <Form.Control
                          type="tel"
                          name="requesterPhone"
                          value={formData.requesterPhone}
                          onChange={handleInputChange}
                          placeholder="Enter phone number"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab.Pane>

                {/* Borrower Details Tab */}
                <Tab.Pane eventKey="borrower">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Borrower Name *</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="borrowerName"
                          value={formData.borrowerName}
                          onChange={handleInputChange}
                          placeholder="Enter borrower name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Borrower Phone *</strong>
                        </Form.Label>
                        <Form.Control
                          type="tel"
                          name="borrowerPhoneNo"
                          value={formData.borrowerPhoneNo}
                          onChange={handleInputChange}
                          placeholder="Enter borrower phone"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Borrower Email</strong>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="borrowerEmail"
                          value={formData.borrowerEmail}
                          onChange={handleInputChange}
                          placeholder="Enter borrower email"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Borrower City</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="borrowerCity"
                          value={formData.borrowerCity}
                          onChange={handleInputChange}
                          placeholder="Enter city"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Borrower Address *</strong>
                        </Form.Label>
                        <div className="d-flex gap-2">
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="borrowerAddress"
                            value={formData.borrowerAddress}
                            onChange={handleInputChange}
                            placeholder="Enter complete address (required for fetching coordinates)"
                            required
                            className="flex-grow-1"
                          />
                          <Button
                            variant="outline-primary"
                            onClick={fetchCoordinates}
                            disabled={
                              fetchingCoordinates ||
                              !formData.borrowerAddress.trim()
                            }
                            className="align-self-start flex-shrink-0"
                            style={{ height: "fit-content" }}
                          >
                            {fetchingCoordinates ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <>
                                <FaMapMarkedAlt className="me-2" />
                                Get Location
                              </>
                            )}
                          </Button>
                        </div>
                        <Form.Text className="text-muted">
                          Enter address and click "Get Location" to fetch
                          latitude and longitude
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Borrower State</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="borrowerState"
                          value={formData.borrowerState}
                          onChange={handleInputChange}
                          placeholder="Enter state"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Latitude</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="borrowerCoordinates.lat"
                          value={formData.borrowerCoordinates.lat}
                          onChange={handleInputChange}
                          placeholder="Latitude"
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Longitude</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="borrowerCoordinates.lng"
                          value={formData.borrowerCoordinates.lng}
                          onChange={handleInputChange}
                          placeholder="Longitude"
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab.Pane>

                {/* Additional Details Tab */}
                <Tab.Pane eventKey="additional">
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Meter Reading (km)</strong>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="meterReading"
                          value={formData.meterReading}
                          onChange={handleInputChange}
                          placeholder="Enter odometer reading"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Owner Serial No</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="ownerSerialNo"
                          value={formData.ownerSerialNo}
                          onChange={handleInputChange}
                          placeholder="Enter owner serial number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Cubic Capacity (cc)</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="cubicCapacity"
                          value={formData.cubicCapacity}
                          onChange={handleInputChange}
                          placeholder="Enter cubic capacity"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Hypothecation Bank</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="hypothecationBank"
                          value={formData.hypothecationBank}
                          onChange={handleInputChange}
                          placeholder="Enter bank name if hypothecated"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Insurance Company</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="insuranceCompany"
                          value={formData.insuranceCompany}
                          onChange={handleInputChange}
                          placeholder="Enter insurance company"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>Insurance Status</strong>
                        </Form.Label>
                        <Form.Select
                          name="insuranceStatus"
                          value={formData.insuranceStatus}
                          onChange={handleSelectChange}
                        >
                          <option value="">Select Insurance Status</option>
                          <option value="active">Active</option>
                          <option value="expired">Expired</option>
                          <option value="not_insured">Not Insured</option>
                          <option value="pending">Pending</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Card.Body>
          </Card>
        </Tab.Container>

        {/* Form Actions */}
        <Card className="shadow-sm">
          <Card.Body className="d-flex justify-content-between">
            <Button
              variant="outline-secondary"
              onClick={handleReset}
              disabled={loading}
            >
              <FaTimesCircle className="me-2" />
              Reset Form
            </Button>

            <div>
              <Button
                variant="outline-primary"
                onClick={() => navigate("/cases")}
                className="me-2"
                disabled={loading}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Creating...
                  </>
                ) : (
                  <>
                    <FaSave className="me-2" />
                    Create Case
                  </>
                )}
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Form>

      {/* Vahan Details Modal */}
      <Modal
        show={showVahanModal}
        onHide={() => setShowVahanModal(false)}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <FaDatabase className="me-2" />
            Vahan Database Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {vahanData ? (
            <>
              <Alert variant="info">
                <strong>Vehicle Found:</strong> {vahanData.vehicleNumber}
                <Badge
                  bg={vahanData.status === "ACTIVE" ? "success" : "danger"}
                  className="ms-2"
                >
                  {vahanData.status}
                </Badge>
              </Alert>

              <Row>
                <Col md={6}>
                  <h6>Vehicle Information</h6>
                  <Table borderless size="sm">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Brand:</strong>
                        </td>
                        <td>{vahanData.vehicleManufacturerName || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Model:</strong>
                        </td>
                        <td>{vahanData.model || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Owner:</strong>
                        </td>
                        <td>{vahanData.owner || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Registration Date:</strong>
                        </td>
                        <td>{formatValue(vahanData.regDate) || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Body Type:</strong>
                        </td>
                        <td>{vahanData.bodyType || "N/A"}</td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                <Col md={6}>
                  <h6>Technical Details</h6>
                  <Table borderless size="sm">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Engine No:</strong>
                        </td>
                        <td>{vahanData.engine || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Chassis No:</strong>
                        </td>
                        <td>{vahanData.chassis || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Seating Capacity:</strong>
                        </td>
                        <td>{vahanData.vehicleSeatCapacity || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Vehicle Weight:</strong>
                        </td>
                        <td>
                          {vahanData.grossVehicleWeight
                            ? `${vahanData.grossVehicleWeight} kg`
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Color:</strong>
                        </td>
                        <td>{vahanData.vehicleColour || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Manufacturing Year:</strong>
                        </td>
                        <td>
                          {vahanData.vehicleManufacturingMonthYear || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>

              {vahanData.rcExpiryDate && (
                <Alert variant="warning" className="mt-3">
                  <strong>RC Expiry:</strong> {vahanData.rcExpiryDate}
                  {vahanData.vehicleInsuranceUpto && (
                    <>
                      <br />
                      <strong>Insurance Valid Until:</strong>{" "}
                      {vahanData.vehicleInsuranceUpto}
                    </>
                  )}
                  {vahanData.vehicleTaxUpto && (
                    <>
                      <br />
                      <strong>Tax Paid Until:</strong>{" "}
                      {vahanData.vehicleTaxUpto}
                    </>
                  )}
                </Alert>
              )}
            </>
          ) : (
            <Alert variant="warning">No Vahan data available</Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowVahanModal(false)}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={applyVahanData}
            disabled={!vahanData}
          >
            <FaCheckCircle className="me-2" />
            Apply to Form
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddCase;
